// File: src/common/enum/historicOccurrence.enum.ts

/**
 * Este enum define os “códigos” (valores) que o backend espera
 * para o tipo de ocorrência histórica. Exatamente: “CREATE”, “UPDATE”, “DELETE” etc.
 */
export enum TypeHistoricOccurrence {
    CREATE = 'CREATE',                   // Criação de registro
    READ = 'READ',                       // Leitura de registro
    UPDATE = 'UPDATE',                   // Atualização de registro
    DELETE = 'DELETE',                   // Exclusão de registro
    DISABLED = 'DISABLED',                 // Registro desativado
    ACTIVATED = 'ACTIVATED',                   // Registro ativado
    CHANGE_STATUS = 'CHANGE_STATUS',     // Mudança de status
    ADDED_DEVICE = 'ADDED_DEVICE',       // Dispositivo adicionado
    ADDED_SERVICE = 'ADDED_SERVICE',     // Serviço adicionado
    ADDED_PRODUCT = 'ADDED_PRODUCT',     // Produto adicionado
    REMOVED_FROM_ORDER = 'REMOVED_FROM_ORDER', // Removido da ordem
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    PENDING = 'PENDING', // Pendente de aprovação
    SUBSCRIPTION = 'SUBSCRIPTION', // Assinatura

}

/**
 * Mapeia cada valor do enum para o texto que o usuário verá na tela.
 */
export const HistoricOccurrenceLabel: Record<TypeHistoricOccurrence, string> = {
    [TypeHistoricOccurrence.CREATE]: 'Criação',
    [TypeHistoricOccurrence.READ]: 'Visualização',
    [TypeHistoricOccurrence.UPDATE]: 'Atualização',
    [TypeHistoricOccurrence.DELETE]: 'Exclusão',
    [TypeHistoricOccurrence.DISABLED]: 'Desativação',
    [TypeHistoricOccurrence.ACTIVATED]: 'Ativação',
    [TypeHistoricOccurrence.CHANGE_STATUS]: 'Mudança de status',
    [TypeHistoricOccurrence.ADDED_DEVICE]: 'Dispositivo adicionado',
    [TypeHistoricOccurrence.ADDED_SERVICE]: 'Serviço adicionado',
    [TypeHistoricOccurrence.ADDED_PRODUCT]: 'Produto adicionado',
    [TypeHistoricOccurrence.REMOVED_FROM_ORDER]: 'Removido da ordem',
    [TypeHistoricOccurrence.APPROVED]: 'Aprovado',
    [TypeHistoricOccurrence.REJECTED]: 'Rejeitado',
    [TypeHistoricOccurrence.PENDING]: 'Pendente de aprovação',
    [TypeHistoricOccurrence.SUBSCRIPTION]: 'Assinatura',

};

/**
 * Mapeia cada valor do enum para uma cor padrão a ser usada na UI.
 */
export const HistoricOccurrenceColor: Record<TypeHistoricOccurrence, string> = {
    [TypeHistoricOccurrence.CREATE]: '#28A745',            // verde
    [TypeHistoricOccurrence.READ]: '#17A2B8',              // azul claro
    [TypeHistoricOccurrence.UPDATE]: '#007BFF',            // azul
    [TypeHistoricOccurrence.DELETE]: '#DC3545',            // vermelho
    [TypeHistoricOccurrence.DISABLED]: '#8C252D',          // cinza
    [TypeHistoricOccurrence.ACTIVATED]: '#28A745',            // verde (ativação
    [TypeHistoricOccurrence.CHANGE_STATUS]: '#6C757D',     // cinza
    [TypeHistoricOccurrence.ADDED_DEVICE]: '#6F42C1',      // roxo
    [TypeHistoricOccurrence.ADDED_SERVICE]: '#FFC107',     // amarelo
    [TypeHistoricOccurrence.ADDED_PRODUCT]: '#20C997',     // verde água
    [TypeHistoricOccurrence.REMOVED_FROM_ORDER]: '#FD7E14',// laranja
    [TypeHistoricOccurrence.APPROVED]: '#28A745',           // verde
    [TypeHistoricOccurrence.REJECTED]: '#DC3545',           // vermelho
    [TypeHistoricOccurrence.PENDING]: '#FFC107',           // amarelo
    [TypeHistoricOccurrence.SUBSCRIPTION]: '#17A2B8',       // azul claro

};
